export const FilterIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '40'}
    height={props?.height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.6668 5H3.3335L16.6668 20.7667V31.6667L23.3335 35V20.7667L36.6668 5Z"
      stroke={props?.color || '#3966E0'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
